import i18n from '../locales/index'
import Web3 from "web3";

const infuraWeb3 = new Web3(new Web3.providers.HttpProvider("https://bsc-testnet.infura.io/v3/9a79dc0c655d4d70a10afbb9274219c1"));

export default infuraWeb3;